import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import type {PageResponse} from "~/services/ApiTypes";
import {supplierEnrichmentProfileUrl} from "~/pages/supplier-360/services/supplier360Urls";
import type {EnrichmentProfile} from "~/pages/supplier-360/types/Supplier360Types";

/** Most-recent enrichment profile for an entity (`GET supplier_360/enrichment_profile/?entity={id}`). Returns results[0] as "current". */
export function useSupplierEnrichmentProfileQuery(entityId: number | undefined) {
    const url = supplierEnrichmentProfileUrl(entityId ?? 0);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => {
            const resp = (await queryHttp.get<PageResponse<EnrichmentProfile>>(url)).data;
            return resp.results[0] ?? null;
        },
        enabled: Boolean(entityId),
    });
}
